export default {"src":"/_next/static/media/lock.d8ca097d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};